import { fadeIn, fadeInUp } from "./Animations.styles";

import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const FormSection = styled.div`
    background: rgba(255, 255, 255, 0.95);
    padding: 14px;
    border-radius: 8px;
    border: none;
    margin-bottom: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s;
    animation: ${fadeInUp} 0.6s ease-out;
    position: relative;
    z-index: 10;

    &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    }
`;

export const FormTitleWrapper = styled.div`
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        color: #4b5563;
        font-size: 16px;
    }
`;

export const FormGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 12px;
`;

export const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const DropdownWithLoader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FormRow = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-end;
    justify-content: space-between;
`;

export const InputWithSuffix = styled.div`
    display: flex;
    align-items: center;
    gap: 1px;

    input {
        max-width: 72px;
        min-height: 25px !important;
        padding: 5px 5px 5px 12px !important;
    }
`;

export const StepButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    align-self: stretch;
`;

export const StepButton = styled.button`
    width: 30px;
    flex: 1;
    border: none;
    border-bottom: 1px solid ${COLOR_VALUES.Gray_6};
    background: #ffffff;
    color: #4b5563;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;

    &:last-child {
        border-bottom: none;
    }

    svg {
        font-size: 14px;
        display: block;
    }

    &:hover:not(:disabled) {
        background: #e5e7eb;
        color: #1f2937;
    }

    &:active:not(:disabled) {
        background: #d1d5db;
    }

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
    }
`;

export const InputSuffix = styled.span`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    margin-left: 6px;
`;

export const CenteredWrapper = styled.div`
    align-self: center;
    margin-top: 22px;

    button {
        transform: scaleY(0.92);
        transform-origin: center;
    }
`;

export const ItalicText = styled.span`
    font-style: italic;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;

    button {
        transform: scale(0.85);
        transform-origin: center;
    }
`;

export const SyncRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
`;

export const QuickButton = styled.button`
    background: ${(props) =>
        props.active ? "white" : "rgba(255, 255, 255, 0.6)"};
    border: 1px solid
        ${(props) => (props.active ? "#9ca3af" : "rgba(209, 213, 219, 0.6)")};
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 11px;
    color: ${(props) => (props.active ? "#1f2937" : "#4b5563")};
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: ${(props) => (props.active ? "600" : "400")};
    box-shadow: ${(props) =>
        props.active ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none"};

    &:hover {
        background: white;
        border-color: #9ca3af;
        color: #1f2937;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }
`;

export const SuccessMessage = styled.div`
    background: linear-gradient(
        135deg,
        rgba(243, 244, 246, 0.8) 0%,
        rgba(249, 250, 251, 0.6) 100%
    );
    border: 1px solid rgba(209, 213, 219, 0.6);
    border-radius: 6px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    animation: ${fadeIn} 0.3s ease-out;

    svg {
        color: #16a34a;
        font-size: 14px;
        background: #e5e7eb;
        border-radius: 50%;
        padding: 3px;
        width: 20px;
        height: 20px;
    }
`;

export const SuccessText = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 12px;
    color: #4b5563;
    font-weight: 500;
`;

export const ErrorMessage = styled.div`
    background: linear-gradient(
        135deg,
        rgba(254, 242, 242, 0.8) 0%,
        rgba(255, 245, 245, 0.6) 100%
    );
    border: 1px solid rgba(252, 165, 165, 0.6);
    border-radius: 6px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    animation: ${fadeIn} 0.3s ease-out;

    svg:first-child {
        color: #dc2626;
        font-size: 14px;
        background: #fee2e2;
        border-radius: 50%;
        padding: 3px;
        width: 20px;
        height: 20px;
        flex-shrink: 0;
    }
`;

export const ErrorText = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 12px;
    color: #4b5563;
    font-weight: 500;
    flex: 1;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
    transition: color 0.2s;
    flex-shrink: 0;

    &:hover {
        color: #4b5563;
    }

    svg {
        font-size: 16px;
    }
`;

export const SubmittedBanner = styled.div`
    background: linear-gradient(
        135deg,
        rgba(241, 245, 249, 0.9) 0%,
        rgba(248, 250, 252, 0.7) 100%
    );
    border: 1px solid rgba(148, 163, 184, 0.5);
    border-radius: 6px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    text-align: center;
    animation: ${fadeIn} 0.3s ease-out;

    svg {
        color: #64748b;
        font-size: 28px;
    }
`;

export const SubmittedTitle = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 13px;
    color: #374151;
    font-weight: 600;
`;

export const SubmittedSubtitle = styled.div`
    font-family: "HelveticaW05Text", "Helvetica", sans-serif;
    font-size: 11px;
    color: #6b7280;
    line-height: 1.5;
`;
